import React from 'react'
import { Tabs, Typography } from 'antd'

import Users from './users/Users'
import Invites from './invites/Invites'
import Calls from './calls/Calls'
import IncompleteProfiles from './incomplete/IncompleteProfiles'
import Reviews from './reviews/Reviews'

const { Title } = Typography
const { TabPane } = Tabs

function Admin() {
	const [state, updateState] = React.useState(0)
	const forceUpdate = React.useCallback(() => updateState(Date.now()), [])

	return (
		<section style={{ minHeight: 600 }}>
			<Title level={3}>Admin Console</Title>
			<Tabs defaultActiveKey="1" onChange={() => forceUpdate()}>
				<TabPane tab="Users" key="1">
					<Users state={state} forceUpdate={forceUpdate} />
				</TabPane>
				<TabPane tab="Invites" key="2">
					<Invites state={state} />
				</TabPane>
				<TabPane tab="Calls" key="3">
					<Calls state={state} />
				</TabPane>
				<TabPane tab="Incomplete Profiles" key="4">
					<IncompleteProfiles state={state} />
				</TabPane>
				<TabPane tab="Reviews" key="5">
					<Reviews state={state} forceUpdate={forceUpdate} />
				</TabPane>
			</Tabs>
		</section>
	)
}

export default Admin
